
import React, { Component } from 'react'
import Paper from 'material-ui/Paper';
import ManageServicesComponent from '../../../../components/services/ManageServicesComponent'
import ServicesCRUDComponent from '../../../../components/services/ServicesCRUDComponent'

import { services as ROLES_CONFIG } from '../../../../config/roles';

import Page403 from 'routes/403/'

export default class ManageServices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (

      <div id="content">
        <div className="row">
          {
            this.props.crud === false ?
              ROLES_CONFIG.manage.indexOf(this.state.role) != -1 ?
                <Paper className="col-sm-11 col-11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                  <ManageServicesComponent />
                </Paper> 
              : <Page403 />
            : null
          }
          {
            this.props.crud === true ? 
              ROLES_CONFIG.service_crud.indexOf(this.state.role) != -1 ?
                <div className="col-sm-11 col-11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                  <ServicesCRUDComponent />
                </div> 
              : <Page403 /> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/services/ManageServices.js